import React from "react";
import * as actions from '../Actions';
export default function ShareMileOverlay({eleRef,tool}){
    return(
    <div className="shareMile-overlay" onClick={()=>{eleRef.shareMileCloseButton()}}>
        <div className="shareMile-popup">
            <div className="shareMile-container">
                <span className="closeButton icon" data-icon-font="C" onClick={() => { eleRef.shareMileCloseButton() }}></span>
                <div className="shareImg-container">
                    <img id="shareMileImg" src="https://cdn.fcglcdn.com/brainbees/community/memoryimages/1560839278549-1560839106.jpg" />
                </div>
                <div className="shareInfo-container">
                    <div className="startShareText">Start Sharing Now !!</div>
                    <span className="R17_61">
                        Your picture has been successfully posted. Now share eleRef picture with family & friends and spread the joy of Parenthood.
                    </span>
                    <div className="shareMileIcons">
                        <span className="icon R28_9e" data-text="facebook">
                            <img src={require('../images/facebook.png')} onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'facebook')} className="facebookimg"/></span>
                        <span className="icon R28_9e" data-text="twitter">
                            <img src={require('../images/twitter.png')} onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'twitter')} className="twitterimg"/></span>
                        <span className="icon R28_9e" data-text="pinterest">
                            <img src={require('../images/pintrest.png')} onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'pintrest')} className="pintrestimg"/></span>
                        <span className="icon R28_9e" data-text="whatsapp">
                            <img src={require('../images/whatsapp.png')} onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'whatsapp')} /></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}



// WEBPACK FOOTER //
// src/shared/tools/common/ShareMileOverlay.js